// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// used to trim project name before checking API with it.
const trimInputValue = (e, b) => {
  e.target.value = e.target.value.trim()
  return b(e)
}

export default trimInputValue
